module.exports = __webpack_public_path__ + "img/product-sc.d50db5af.svg";